import React, { useEffect, useRef, useState } from "react";
import Headerbar from "../../../Components/InnerLayout/Headerbar";
import UserInterface from "../../../Components/InnerLayout/UserInterface";
import MultiRangeSlider from "../../../Components/MultiRangeSlider";
const IncomingPayments = (params) => {
  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />
        <div className="inner-content">
          <div className="container px-0">
            <div className="row mx-0">
              <div className="container px-0">
                <div className="top-header-sec mb-1">
                  <div className="col-12 mt-3">
                    <h4 className="event-alert br-btm-0">
                      Incoming Payments
                      <div className="clear"></div>
                    </h4>
                  </div>
                </div>
              </div>
            </div>

            <div class="row mx-0">
              <div class="shadowclass top_filters orderpayy mb-3 mt-0">
                <h4 class="event-alert py-0 my-2">Filters </h4>
                <div className="row mx-0">
                  <div class="col-lg-4 col-md-6 pl0 px-0 px-sm-3">
                    <div class="calander d-flex align-items-center">
                      <div class="datePicker pading_right">
                        <div class="input-append bootstrap-timepicker date-input datepicker2 date">
                          <input
                            name="from_date"
                            class=" "
                            required="required"
                            type="text"
                            id=""
                            value="2022-05-01"
                          />
                          <span class="add-on">
                            <i class="fa fa-calendar"></i>
                          </span>
                        </div>
                      </div>
                      <div class="datePicker pading_lect">
                        <div class="input-append bootstrap-timepicker date-input datepicker2 date">
                          <input
                            name="to_date"
                            class=" "
                            required="required"
                            type="text"
                            id=""
                            value="2022-05-13"
                          />
                          <span class="add-on">
                            <i class="fa fa-calendar"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-2 col-md-6 timing-duration pt-4 pt-sm-0">
                    <MultiRangeSlider
                      min={0}
                      max={1000}
                      onChange={({ min, max }) =>
                        console.log(`min = ${min}, max = ${max}`)
                      }
                    />
                  </div>
                  <div class="selecters col-lg-5 col-md-10 pl-md-0 row mx-0 justify-content-between pt-0 pt-lg-0">
                    <div class="select-div col px-1 pl-md-0">
                      <div class="input select">
                        <select
                          name="waste_group"
                          class="csutom_select"
                          id="WasteWasteGroup"
                        >
                          <option value="">Customer </option>
                        </select>
                      </div>{" "}
                    </div>
                    <div class="select-div col px-1">
                      <div class="input select">
                        <select
                          name="waste_type"
                          class="csutom_select"
                          id="WasteWasteType"
                        >
                          <option value="">Status</option>
                        </select>
                      </div>{" "}
                    </div>
                  </div>
                  <div class="col-lg-1 col px-0 pt-3 pt-lg-0 align-right">
                    <button class="btn btn_btnblue" type="submit">
                      Search
                    </button>
                  </div>
                </div>
              </div>{" "}
            </div>

            <div className="row mx-0">
              <div className="container px-0">
                <div className="top-header-sec mb-1">
                  <div className="col-12 mt-3">
                    <h4 className="event-alert br-btm-0">
                      Incoming Payments List
                      <div className="clear"></div>
                    </h4>
                    <div className="row justify-content-between align-items-center">
                      <div className="col-md-4">
                        <div className="search-box mt-0">
                          <form type="GET">
                            <input
                              type="text"
                              placeholder="Search"
                              name="keyword1"
                            />
                            <input type="submit" />
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mx-0">
              <div class="shadowclass">
                <div class="col-12">
                  <div class="counts">
                    <div className="shadowclass mt-0 p-0">
                      <div className="table-responsive">
                        <table className="checklist-table remove-space inventory_table">
                          <thead>
                            <tr>
                              <th> ID </th>
                              <th> Customer </th>
                              <th> Invoice ID </th>
                              <th> Total Value </th>
                              <th> Payment Date </th>
                              <th class="action-td"> Actions </th>
                            </tr>
                          </thead>
                          <tbody></tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </UserInterface>
  );
};
export default IncomingPayments;
